import { createReducer, on } from "@ngrx/store";
import { initReleaseTransactionsState } from '../Models/Drafts/InitReleaseTransactionsState';
import { InitReleaseActions } from '../actions';
import { CreateCustomRule } from "../Models/CreateCustomRule/CreateCustomRule";

export const initReleaseTransactionKey = 'inrTransactionsState';
export interface State extends initReleaseTransactionsState { }


export const initInRTransactionsState: State = {
  initReleaseTransactions: [],
  getCustomRuleSection: [],
  inrTransactionInContext: {
    draftId: '',
    draftObject: {
      formType: '',
      amountType: '',
      amount: '',
      masterAccountId: '',
      isFromSLOA: false,
      stateTaxAmount: '',
      fedTaxAmount: '',
      subAccountId: '',
      trustIncmPct: '',
      trustPrinPct: '',
      trustTaxCode: '',
      tranMemo: '',
      hasWpfaRole: false,
      isRecurringTransaction: false,
      taxPayerId: '',
      taxTypeCode: '',
      taxMonth: '',
      taxYear: '',
    },
    masterAccount: "",
    subAccount: "",
    transactionStatus: "",
    transactionType: "",
    transactionAmount: 0,
    transactionProcessDate: "",
    createDate: "",
    lastEditedDate: "",
    closedDate: "",
    createdByLoginId: "",
    isMoveMoneyAuthorized: false,
    fundsDirection: "",
    sloaAccountData: {
      expandReporting: false,
      isExpandReportingCheck: false,
      isExpandReportingJournal: false,
      isExpandReportingWire: false,
      hasError: false,
      errorText: '',
      hasSLOAOverflow: false,
      allSLOAList: []
    },
    accountData: {
      isTrust: false,
      accountProductCode: '',
      accountRegistrationTypeCode: '',
      availableCashMmf: '',
      hasWpfaRole: false,
      hasLpfaRole: false,
      hasNdfaRole: false,
      icsProcessDate: '',
      stateCd: '',
      isRmdEligible: false,
      isRmdToDisplay: false,
      stwProcessCode: '',
      stwMinimumTaxAmount: 0,
      defaultStateTaxRate: 0,
      availableCashOnMargin: '',
      rmdAnnualAmount: '',
      rmdAnnualRemainingAmount: '',
      rmdAnnualPaidYearToDateAmount: '',
      isNonNaState: false,
      isFederalState: false,
      accountPlatformCode: '',
      moneyLinkBusinessDate: '',
    }
  },
  initReleaseTransactionCallSuccess: false,
  initReleaseTransactionFails: false,
  initReleaseTransactionsByDraftIdCallStarted: false,
  initReleaseTransactionsByDraftIdCallSuccess: false,
  initReleaseTransactionsByDraftIdCallCompleted: false,
  initReleaseTransactionDeleteCallCompleted: false,
  initReleaseTransactionDeleteCallFailed: false,
  isSloa: false,
  createCustomRuleSection: {} as CreateCustomRule,
  initReleaseCustomRulePostStarted: false,
  initReleaseCustomRulePostSuccess: false,
  initReleaseCustomRulePostFailed: false,
  initReleaseCustomRuleGetStarted: false,
  initReleaseCustomRuleGetSuccess: false,
  initReleaseCustomRuleGetFailed: false,
  initReleaseCustomRuleDeleteStarted: false,
  initReleaseCustomRuleDeleteSuccess: false,
  initReleaseCustomRuleDeleteFailed: false
};

export const initReleaseTransactionsReducer = createReducer(
  initInRTransactionsState,
  on(InitReleaseActions.getInitReleaseList,  (state) => {
    return {
      ...initInRTransactionsState
    }
  }),
  on(InitReleaseActions.getInitReleaseListSuccessful, (state, response) => {
    return {
      ...state,
      initReleaseTransactions: response.data,
      initReleaseTransactionCallSuccess: true
    }
  }),
  on(InitReleaseActions.getInitReleaseListFailed, (state, response) => {
    return {
      ...initInRTransactionsState,
      initReleaseTransactionFails: true
    }
  }),
  on(InitReleaseActions.callInitReleaseByDraftId, (state, { isSloa }) => {
    return { ...state, initReleaseTransactionsByDraftIdCallStarted : true, isSloa: isSloa }
  }),
  on(InitReleaseActions.initReleaseByDraftIdSuccessful, (state, { response, isSloa }) => {
    return {
      ...state,
      initReleaseTransactionsByDraftIdCallSuccess: true,
      initReleaseTransactionsByDraftIdCallCompleted: true,
      initReleaseTransactionsByDraftIdCallStarted: false,
      inrTransactionInContext: {
        ...response,
        draftObject: {
          ...response.draftObject,
          formType: response.transactionType === 'journal' ?
                    state.initReleaseTransactions.find(draft => draft.attributes.draftId === response.draftId)?.attributes.formType ?? '' :
                    response.draftObject.formType,
        }
      }
    }
  }),
  on(InitReleaseActions.initReleaseByDraftIdFailed, (state, response) => {
    return {
      ...initInRTransactionsState,
      initReleaseTransactionsByDraftIdCallSuccess: false,
      initReleaseTransactionsByDraftIdCallCompleted: true,
      initReleaseTransactionsByDraftIdCallStarted: false,
    }
  }),
  on(InitReleaseActions.deleteInitiatedDraft, (state) => {
    return {
      ...state,
      initReleaseTransactionDeleteCallFailed: false,
      initReleaseTransactionDeleteCallCompleted: false
    }
  }),
  on(InitReleaseActions.deleteInitiatedDraftSuccessful, (state) => {
    return {
      ...state,
      initReleaseTransactionDeleteCallFailed: false,
      initReleaseTransactionDeleteCallCompleted: true
    }
  }),
  on(InitReleaseActions.deleteInitiatedDraftFailed, (state) => {
    return {
      ...state,
      initReleaseTransactionDeleteCallFailed: true,
      initReleaseTransactionDeleteCallCompleted: true
    }
  }),
  on(InitReleaseActions.saveCreateRuleValues, (state, { createCustomRuleSection }) => ({
    ...state,
    createCustomRuleSection
  })),
  on(InitReleaseActions.callCreateCustomRulesPost, (state) => ({
    ...state,
    initReleaseCustomRulePostStarted: true,
    initReleaseCustomRulePostSuccess: false,
    initReleaseCustomRulePostFailed: false
  })),
    on(InitReleaseActions.callCustomRulesPostSuccessful, (state) => ({
    ...state,
    initReleaseCustomRulePostStarted: false,
    initReleaseCustomRulePostSuccess: true,
    initReleaseCustomRulePostFailed: false
  })),
    on(InitReleaseActions.callCustomRulesPostFailed, (state) => ({
    ...state,
    initReleaseCustomRulePostStarted: false,
    initReleaseCustomRulePostSuccess: false,
    initReleaseCustomRulePostFailed: true
    })),
  on(InitReleaseActions.callCustomRulesGetSuccessful, (state, { response }) => ({
    ...state,
    getCustomRuleSection: response
  })),
  on(InitReleaseActions.callCreateCustomRulesGet, (state) => ({
      ...state,
      initReleaseCustomRuleGetStarted: true,
      initReleaseCustomRuleGetSuccess: false,
      initReleaseCustomRuleGetFailed: false
  })),
  on(InitReleaseActions.callCustomRulesGetSuccessful, (state) => ({
      ...state,
        initReleaseCustomRuleGetStarted: false,
        initReleaseCustomRuleGetSuccess: true,
        initReleaseCustomRuleGetFailed: false
    })),
  on(InitReleaseActions.callCustomRulesGetFailed, (state) => ({
      ...state,
      initReleaseCustomRuleGetStarted: false,
      initReleaseCustomRuleGetSuccess: false,
      initReleaseCustomRuleGetFailed: true
  })),
  on(InitReleaseActions.callCustomRulesDeleteByRuleId, (state) => ({
      ...state,
      initReleaseCustomRuleDeleteStarted: true,
      initReleaseCustomRuleDeleteSuccess: false,
      initReleaseCustomRuleDeleteFailed: false
  })),
  on(InitReleaseActions.callCustomRulesDeleteSuccessful, (state) => ({
      ...state,
      initReleaseCustomRuleDeleteStarted: false,
      initReleaseCustomRuleDeleteSuccess: true,
      initReleaseCustomRuleDeleteFailed: false
    })),
  on(InitReleaseActions.callCustomRulesDeleteFailed, (state) => ({
      ...state,
      initReleaseCustomRuleDeleteStarted: false,
      initReleaseCustomRuleDeleteSuccess: false,
      initReleaseCustomRuleDeleteFailed: true
  })),
)
